(function () {
  'use strict';

  if (window.__nepheOptionPlusInit) return;
  window.__nepheOptionPlusInit = true;

  var STANDARD_OPTIONS = ['Side', 'Flex', 'Curve'];

  function getRadioGroup(scope, optionName) {
    var root = scope || document;
    return Array.from(root.querySelectorAll('input[type="radio"]')).filter(function (r) {
      var n = r.getAttribute('name') || '';
      return n.indexOf(optionName + '-') === 0;
    });
  }

  function getStandardRadios(scope, optionName) {
    return getRadioGroup(scope, optionName).filter(function (r) {
      return r.value !== 'NEPHE+';
    });
  }

  function getCurrentStandardValue(scope, optionName) {
    var radios = getStandardRadios(scope, optionName);
    var checked = radios.find(function (r) { return r.checked; });
    if (checked) return checked.value;
    return radios.length ? radios[0].value : '';
  }

  function fillProperty(wrapper, optionName, value) {
    var input = wrapper.querySelector('[data-nephe-pref-input="' + optionName + '"]');
    if (input) input.value = value;
  }

  function setPropertyDisabled(wrapper, disabled) {
    wrapper.querySelectorAll('[data-nephe-pref-input]').forEach(function (i) {
      i.disabled = disabled;
    });
    var textInput = wrapper.querySelector('.nephe-option-plus__input');
    if (textInput) {
      textInput.disabled = disabled;
      if (disabled) textInput.value = '';
    }
  }

  function showAdjustNote(wrapper, show) {
    var note = wrapper.querySelector('.nephe-option-plus__adjust-note');
    if (!note) return;
    if (show) note.removeAttribute('hidden'); else note.setAttribute('hidden', '');
  }

  function getBuyFormIdInput() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function bindWrapper(wrapper) {
    if (wrapper.__nepheBound) return;
    wrapper.__nepheBound = true;

    var checkbox = wrapper.querySelector('.nephe-option-plus__checkbox');
    if (!checkbox) return;
    var nephePlusVariantId = wrapper.getAttribute('data-nephe-plus-variant-id');
    if (!nephePlusVariantId) return;

    var idInput = getBuyFormIdInput();
    if (!idInput) return;

    var standardIdBeforeNephe = idInput.value;
    var idObserver = null;

    function refreshPrefs() {
      STANDARD_OPTIONS.forEach(function (opt) {
        fillProperty(wrapper, opt, getCurrentStandardValue(document, opt));
      });
    }

    function setStandardRadiosDisabled(disabled) {
      STANDARD_OPTIONS.forEach(function (opt) {
        getStandardRadios(document, opt).forEach(function (r) {
          r.disabled = disabled;
          var label = r.closest('.variant-option__button-label');
          if (label) {
            if (disabled) label.classList.add('variant-option__button-label--nephe-locked');
            else label.classList.remove('variant-option__button-label--nephe-locked');
          }
        });
      });
    }

    function forceNephePlusId() {
      if (idInput.value !== nephePlusVariantId) {
        idInput.value = nephePlusVariantId;
      }
    }

    function activateNephePlus() {
      standardIdBeforeNephe = idInput.value;
      forceNephePlusId();
      refreshPrefs();
      setStandardRadiosDisabled(true);
      setPropertyDisabled(wrapper, false);
      showAdjustNote(wrapper, true);

      // Garder l'id sur la variante NEPHE+ même si variant-picker le change
      if (idObserver) idObserver.disconnect();
      idObserver = new MutationObserver(function () {
        if (checkbox.checked && idInput.value !== nephePlusVariantId) {
          idInput.value = nephePlusVariantId;
        }
      });
      idObserver.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    function deactivateNephePlus() {
      if (idObserver) {
        idObserver.disconnect();
        idObserver = null;
      }
      setStandardRadiosDisabled(false);
      // Restaure l'id selon les radios standards actuels
      var sideVal = getCurrentStandardValue(document, 'Side');
      var flexVal = getCurrentStandardValue(document, 'Flex');
      var curveVal = getCurrentStandardValue(document, 'Curve');
      var matched = findStandardVariantId(sideVal, flexVal, curveVal);
      idInput.value = matched || standardIdBeforeNephe;
      setPropertyDisabled(wrapper, true);
      showAdjustNote(wrapper, false);
    }

    function findStandardVariantId(side, flex, curve) {
      var data = window.__nepheVariantsCache;
      if (!data) {
        var script = document.querySelector('variant-picker script[type="application/json"]');
        // Pas de map globale fiable; on s'appuie sur le dataset des radios
      }
      var radios = getStandardRadios(document, 'Side').filter(function (r) {
        return r.value === side;
      });
      // Fallback: laisser variant-picker gérer en re-déclenchant un change sur les radios standards
      var sideRadio = getStandardRadios(document, 'Side').find(function (r) { return r.value === side; });
      if (sideRadio && !sideRadio.checked) {
        sideRadio.checked = true;
        sideRadio.dispatchEvent(new Event('input', { bubbles: true }));
        sideRadio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (sideRadio) {
        sideRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return null; // l'id sera mis à jour par variant-picker
    }

    checkbox.addEventListener('change', function () {
      if (checkbox.checked) activateNephePlus();
      else deactivateNephePlus();
    });

    // Quand le user change Side/Flex/Curve avec NEPHE+ coché, capturer la nouvelle préférence
    document.addEventListener('change', function (e) {
      if (!checkbox.checked) return;
      var radio = e.target;
      if (!radio || radio.type !== 'radio') return;
      var name = radio.getAttribute('name') || '';
      var optionName = STANDARD_OPTIONS.find(function (opt) {
        return name.indexOf(opt + '-') === 0;
      });
      if (!optionName || radio.value === 'NEPHE+') return;
      fillProperty(wrapper, optionName, radio.value);
      // L'observer va re-forcer l'id NEPHE+ si variant-picker l'a changé
    });

    // Filet de sécurité au submit
    var form = idInput.form;
    if (form) {
      form.addEventListener('submit', function () {
        if (checkbox.checked) idInput.value = nephePlusVariantId;
      }, true);
    }

    // État initial
    setPropertyDisabled(wrapper, true);
    showAdjustNote(wrapper, false);
  }

  function init(scope) {
    var root = (scope && scope.target && scope.target.querySelectorAll) ? scope.target : document;
    root.querySelectorAll('.nephe-option-plus').forEach(bindWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
